import React, { useEffect, useState } from "react";
import FormValidator from "../../FormValidator";
import { notifyError, notifySuccess } from "../../helper";
import client from "../../api";
import { MAIL_ACCOUNT_ALL_LINK } from "../../constants/constants";
import DraftEditor from "../DraftEditor";

const EditProfilePopUp = (props) => {
    const api = client();
    const [formData, setFormData] = useState(props.profileData);
    const [loading, setLoading] = useState(false);
    const validatorRules = {
        name: {
            empty: "Please Enter Full Name"
        }
    }
    const validatorObject = new FormValidator(validatorRules);
    const [error, setError] = useState({});

    const removeError = (e) => {
        setError({ ...error, [e.target.name]: "" });
    }
    const fieldBlur = e => {
        const fieldError = validatorObject.validateFields(e.target.value, e.target.name)
        if (Object.keys(fieldError).length) setError({ ...error, ...fieldError });        
    }

    const fieldFocus = e => {
        removeError(e);
        //update()
    }
    const validateAllFields = (inputs) => {
        const v = validatorObject.validateFields(inputs);
        if(Object.keys(v).length === 0){
            return true;
        } else {
            setError({...v});
            return false;
        }       
    }
    const handleInputChange = (e) => {
        const {name,value}= e.target;
        setFormData((prevData)=>({
            ...prevData,
            [name]:value,
        }));
    }

    const handleSignatureChange = () => {
        return (e) => {
            setFormData((prevData)=>({...prevData, signature:e}));            
        }
    }

    // const onEditorBlur = (key,index) => {
    //     return(e) =>{
    //         if(((e.target).innerText).length <= 1){
    //             const updateErrors = errors.filter((err,i)=>{
    //                 if(index === i){
    //                     err[key] = "Please enter signature body";                        
    //                 }
    //                 return err;
    //             })
    //             setErrors([...updateErrors]);
    //         } 
    //     }
    // }
    // const onEditorFocus = (key,index) => {
    //     return(e) =>{
    //         const updateErrors = errors.filter((err,i)=>{
    //             if(index === i){
    //                 err[key] = "";
    //             }
    //             return err;
    //         })
    //         setErrors([...updateErrors]); 
    //     }
    // }

    const filterValues = (inputValues) => {
        return {
            name: inputValues.name,
            email:inputValues.email,
            signature:inputValues.signature
        }
    };
    const updateProfileInfo = async () => {
        setLoading(true);
        try{
            if(validateAllFields(formData)){
                const filteredData = filterValues(formData);
                const response = await api.post('/v1/mailAccount/profile/update',{
                    ...filteredData
                });
                if(response.status === 200 || response.status === 201){
                    notifySuccess('Email Profile updated');
                    setLoading(false);
                    setTimeout(()=>{
                        props.setPopupDisplay(false);
                        window.location.href = MAIL_ACCOUNT_ALL_LINK;
                    },2500);
                }

            } else {
                setLoading(false);
            }
        } catch(error){
            setLoading(false);
            if(error.status === 400) notifyError('Bad Request. Not able to update account profile. Please try again');            
        }
    }
    
    return(<>
        <div className="popup-wrap">
            <span 
                className="close-icon" 
                onClick={()=>{
                    props.setPopupDisplay(false);
                }}>
                <i className="bx bx-x"></i>
            </span>
            <div className="popup">
                <form onSubmit={(e)=>{e.preventDefault();}} encType="multipart/form-data" method="post">
                    <h3>Update Profile</h3>
                    <input type="hidden" defaultValue={formData.email} />
                    
                    <div className="field-wrap">
                        <label className="label-xs">Name</label>
                        <input 
                            type="text"
                            name="name" 
                            placeholder="Full Name" 
                            value={formData.name}
                            onChange={handleInputChange}
                            onBlur={(e)=>{
                                fieldBlur(e);
                            }}
                            onFocus={(e) =>{
                                fieldFocus(e)
                            }}
                        />
                        {error.name && <span className="validation-error">{error.name}</span>}
                    </div>
                    <div className="field-wrap">
                        <label className="label-xs">Signature</label>
                        {/* <textarea
                        name="signature"
                        value={formData.signature}
                        onChange={handleInputChange}
                        onBlur={(e)=>{
                            fieldBlur(e);
                        }}
                        onFocus={(e) =>{
                            fieldFocus(e)
                        }}
                        /> */}
                        {formData.signature ? <DraftEditor
                            emailVariables={false}
                            className={'profile-popup-editor'}
                            onContentChange={handleSignatureChange()}
                            defaultContent={formData.signature}
                            onBlur={(e)=>{
                                //onEditorBlur(e);
                            }}
                            onFocus={(e) =>{
                                //onEditorFocus(e)
                            }}
                        />:<DraftEditor
                        emailVariables={false}
                        className={'profile-popup-editor'}
                        onContentChange={handleSignatureChange()}
                        defaultContent={''}
                        onBlur={(e)=>{
                            //onEditorBlur(e);
                        }}
                        onFocus={(e) =>{
                            //onEditorFocus(e)
                        }}
                    />}
                        {error.signature && <span className="validation-error">{error.signature}</span>}
                    </div>
                    <div className="field-wrap">
                        <button 
                            className={loading ? "primary-btn button--loading":"primary-btn"}
                            onClick={()=>{
                                updateProfileInfo();
                        }}><span className="button--text">Update</span></button>
                    </div>
                </form>
            </div>
        </div>    
    </>);
}

export default EditProfilePopUp;